// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuySe5Yq88pOVQaqN_Fk{position:fixed;pointer-events:\"none\";z-index:1000;top:0;font-size:12px;font-weight:400}html[dir] .QuySe5Yq88pOVQaqN_Fk{border-width:1px;border-style:solid;padding:0 4px;background:var(--neutralTertiary)}html[dir=ltr] .QuySe5Yq88pOVQaqN_Fk{left:0}html[dir=rtl] .QuySe5Yq88pOVQaqN_Fk{right:0}html[dir=ltr] .hgeM7hid0XMeiC1RaYTF{margin-right:-6px}html[dir=rtl] .hgeM7hid0XMeiC1RaYTF{margin-left:-6px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dragHelperStyle": "QuySe5Yq88pOVQaqN_Fk",
	"favoriteButton": "hgeM7hid0XMeiC1RaYTF"
};
module.exports = ___CSS_LOADER_EXPORT___;
